import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgLocationIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M12.0002 12.96c1.6154 0 2.925-1.2894 2.925-2.88s-1.3096-2.88-2.925-2.88-2.925 1.2894-2.925 2.88 1.3096 2.88 2.925 2.88" />
      <path d="M12.0002 21.6c3.9-3.84 7.8-7.2784 7.8-11.52s-3.4922-7.68-7.8-7.68-7.8 3.4385-7.8 7.68 3.9 7.68 7.8 11.52" />
    </g>
  </svg>
);
export default SvgLocationIcon;
